import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaCalendarAlt,
  FaClock,
  FaClipboardList,
} from "react-icons/fa";

const BRAND_GRADIENT = "linear-gradient(135deg, #5f2eea, #0a84ff)";

/* ================= WRAPPER ================= */

const Wrapper = styled.div`
  min-height: 100vh;
  padding: 40px 20px;
  font-family: "Poppins", sans-serif;
  color: #fff;
`;

/* ================= HEADER ================= */

const Header = styled.div`
  margin-bottom: 40px;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  background: ${BRAND_GRADIENT};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Subtitle = styled.p`
  color: #cbd5e1;
  margin-top: 8px;
`;

/* ================= GRID ================= */

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 24px;
`;

/* ================= CARD ================= */

const Card = styled(motion.div)`
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(14px);
  border-radius: 18px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
`;

const IconWrapper = styled.div`
  font-size: 26px;
  margin-bottom: 16px;
`;

const CardTitle = styled.h3`
  font-size: 1rem;
  margin-bottom: 6px;
`;

const Value = styled.h2`
  font-size: 1.6rem;
  font-weight: 700;
`;

/* ================= ACTION SECTION ================= */

const Section = styled.div`
  margin-top: 50px;
`;

const SectionTitle = styled.h2`
  margin-bottom: 20px;
  font-size: 1.4rem;
`;

const ActionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
`;

const ActionCard = styled(motion.div)`
  padding: 20px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  cursor: pointer;
  text-align: center;
`;

const ActionText = styled.p`
  margin-top: 10px;
  font-weight: 600;
`;

/* ================= COMPONENT ================= */

export default function EmployeeDashboard() {
  return (
    <Wrapper>
      <Header>
        <Title>Employee Dashboard</Title>
        <Subtitle>Welcome back. Here's your personal overview.</Subtitle>
      </Header>

      <Grid>
        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaUserCheck />
          </IconWrapper>
          <CardTitle>Attendance Status</CardTitle>
          <Value>Present</Value>
        </Card>

        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaCalendarAlt />
          </IconWrapper>
          <CardTitle>Leave Balance</CardTitle>
          <Value>8 Days</Value>
        </Card>

        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaClock />
          </IconWrapper>
          <CardTitle>Today's Work Hours</CardTitle>
          <Value>6h 25m</Value>
        </Card>

        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaClipboardList />
          </IconWrapper>
          <CardTitle>Pending Leave Requests</CardTitle>
          <Value>1</Value>
        </Card>
      </Grid>

      <Section>
        <SectionTitle>Quick Actions</SectionTitle>

        <ActionGrid>
          <ActionCard whileHover={{ scale: 1.05 }}>
            <FaClock size={24} />
            <ActionText>Punch In / Out</ActionText>
          </ActionCard>

          <ActionCard whileHover={{ scale: 1.05 }}>
            <FaCalendarAlt size={24} />
            <ActionText>Apply Leave</ActionText>
          </ActionCard>

          <ActionCard whileHover={{ scale: 1.05 }}>
            <FaClipboardList size={24} />
            <ActionText>View Attendance</ActionText>
          </ActionCard>
        </ActionGrid>
      </Section>
    </Wrapper>
  );
}
